import React, { useCallback, useEffect } from 'react';
import useAnimationStore from '../../../../../common/store/useAnimationStore';

const useAnimation = (
  wrapper: React.RefObject<HTMLDivElement>,
  text: React.RefObject<HTMLParagraphElement>,
  top: React.RefObject<HTMLDivElement>,
  bottom: React.RefObject<HTMLDivElement>
) => {
  const timeline = useAnimationStore(useCallback(state => state.landing.somersby.subtitle, []));

  useEffect(() => {
    const defaults = {
      duration: 1.5,
      ease: "power2.out"
    }

    timeline.to(wrapper.current, { duration: 0, opacity: "1" });
    timeline.to([top.current, bottom.current], { ...defaults, width: "50.2%" });
    timeline.to([top.current, bottom.current], { duration: 0, width: "100%" });
    timeline.to(text.current, { duration: 0, opacity: "1" });
    timeline.to([top.current, bottom.current], { ...defaults, height: "0%" });

    return () => { timeline.clear() }
  }, []);
}

export default useAnimation;